var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "fb-share-button",
        attrs: {
          "data-href": _vm.url,
          "data-layout": "button_count",
          "data-size": "small",
        },
      },
      [
        _c(
          "a",
          {
            staticClass: "fb-xfbml-parse-ignore",
            attrs: { target: "_blank", href: _vm.url },
          },
          [_vm._v("Share")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }